import React from 'react';
import {
  always,
  equals,
  compose,
  cond,
  curry,
  length,
  map,
  T as otherwise,
} from 'ramda';


const xmlns = 'http://www.w3.org/2000/svg';
const xlinkns = 'http://www.w3.org/1999/xlink';
const width = 250;
const height = 250;
const colors = [
  '#182831',
  '#205883',
  '#0272B6',
  '#b3b3b3',
  '#333333',
  '#b61402',
];
const shapes = [
  'voicemail',
  'phone',
  'cell-phone',
];

const randomColor = () => colors[Math.floor(Math.random() * length(colors))];

const randomShape = () => shapes[Math.floor(Math.random() * length(shapes))];

const randomBase = curry((min, max) => Math.random() * (max - min) + min);

const randomPos = max => Math.floor(randomBase(-20, max + 20));

const randomScale = (min, max) => parseFloat(randomBase(min, max).toFixed(2));

const randomScaleForShape = cond([
  [equals('voicemail'), () => randomScale(4, 8)],
  [equals('phone'), () => randomScale(5, 9)],
  [equals('cell-phone'), () => randomScale(5, 9)],
  [otherwise, always(3)],
]);


// function addElement(name) {
//   const g = document.createElementNS(xmlns, 'g');
//   const use = document.createElementNS(xmlns, 'use');
//   const field = document.getElementById('field');
//   const t = `translate(${randomPos(width)},${randomPos(height)}) ` + `scale(${randomScaleForShape(name)})`;
//   use.setAttributeNS(xlinkns, 'xlink:href', `#${name}`);
//   g.setAttribute('style', `stroke: ${randomColor()};`);
//   g.setAttributeNS(null, 'transform', t);
//   g.appendChild(use);
//   field.appendChild(g);
// }

export default () => (
  <svg
    version="1.1"
    width="250px"
    height="250px"
    viewBox="0 0 250 250"
    preserveAspectRatio="xMidYMax slice"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <svg xmlns="http://www.w3.org/2000/svg" id="voicemail">
        <circle cx="5.5" cy="11.5" r="4.5" />
        <circle cx="18.5" cy="11.5" r="4.5" />
        <line x1="5.5" y1="16" x2="18.5" y2="16" />
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" id="phone">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" id="cell-phone">
        <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
        <line x1="6.5" y1="17" x2="17.5" y2="17" strokeWidth="0.5" />
        <circle cx="12" cy="19.25" r="0.5" />
      </svg>
    </defs>
    <style
      type="text/css"
      dangerouslySetInnerHTML={{
        __html: 'svg { fill: none; }',
      }}
    />
    <rect x="0" y="0" width="100%" height="100%" fill="#F2F4F5" />
    <g>
      {map(
        compose(
          shape => (
            <g
              transform={`translate(${
                randomPos(width)
              }, ${
                randomPos(height)
              }) scale(${
                randomScaleForShape(shape)
              })`}
              style={`stroke: ${randomColor()};`}
            >
              <use xlinkHref={`#${shape}`} className={shape} />
            </g>
          ),
          randomShape,
        ),
        Array.apply(0, Array(8)),
      )}
    </g>
  </svg>
);
